/* eslint no-alert: 0 */
import React from 'react';
import $ from 'jquery';

const resetFilePicker = () => {
    const $filePicker = $('#file-input');
    $filePicker.wrap('<form>').closest('form').get(0).reset();
    $filePicker.unwrap();
};

class FilePicker extends React.Component {
    inputChange = (e) => {
        const { target } = e;
        this.props.handleFiles(target.files);
        resetFilePicker();
    };

    render() {
        return (
            <input id="file-input" type="file" onChange={this.inputChange} />
        );
    }
}

export default FilePicker;
